import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'listbox-selection',
    templateUrl: './listbox-selection.component.html',
    styleUrls: ['./listbox-selection.component.scss'],
    host: {
        class: 'listbox-selection'
    },
    standalone: false
})
export class ListBoxSelectionComponent implements OnInit {
  @Input() availableItems: { label: string; value: any }[] = [];
  @Input() selectedItems: { label: string; value: any }[] = [];
  @Input() showSearchBox = true; // Controls visibility of search box
  @Output() selectionChange = new EventEmitter<{ label: string; value: any }[]>();

  public availableFilteredItems: { label: string; value: any }[] = [];
  public selectedFilteredItems: { label: string; value: any }[] = [];
  public availableSearchTerm: any = '';
  public selectedSearchTerm: any = '';
  public selectedItem: { label: string; value: any } | null = null;
  private originalOrder: { label: string; value: any }[] = [];

  ngOnInit(): void {
    this.setItems(this.availableItems, this.selectedItems);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['availableItems']) {
      this.originalOrder = JSON.parse(JSON.stringify(this.availableItems)); // Update the deep copy if availableItems changes
    }
  }

  public setItems(availableItems: any, selectedItems: any){
    this.availableItems = availableItems;
    this.selectedItems = selectedItems;
    this.availableFilteredItems = [...availableItems];
    this.selectedFilteredItems = [...selectedItems];
    this.originalOrder = JSON.parse(JSON.stringify(availableItems)); // Create a deep copy of the original items
  }

  filterItems(list: 'available' | 'selected'): void {
    if (list === 'available') {
      this.availableFilteredItems = this.availableItems.filter(item =>
        item.label.toLowerCase().includes(this.availableSearchTerm.toLowerCase())
      );
    } else {
      this.selectedFilteredItems = this.selectedItems.filter(item =>
        item.label.toLowerCase().includes(this.selectedSearchTerm.toLowerCase())
      );
    }
  }

  selectItem(item: { label: string; value: any }): void {
    this.selectedItem = item;
  }

  moveToSelected(): void {
    if (this.selectedItem) {
      this.availableItems = this.availableItems.filter(i => i !== this.selectedItem);
      this.selectedItems.push(this.selectedItem);
      this.sortItems();
      this.selectedItem = null;
      this.filterItems('available');
      this.filterItems('selected');
      this.selectionChange.emit(this.selectedItems);
    }
  }

  moveToAvailable(): void {
    if (this.selectedItem) {
      this.selectedItems = this.selectedItems.filter(i => i !== this.selectedItem);
      this.availableItems.push(this.selectedItem);
      this.sortItems();
      this.selectedItem = null;
      this.filterItems('available');
      this.filterItems('selected');
      this.selectionChange.emit(this.selectedItems);
    }
  }

  moveAllToSelected(): void {
    this.selectedItems = [...this.selectedItems, ...this.availableItems];
    this.availableItems = [];
    this.sortItems();
    this.selectedItem = null;
    this.filterItems('available');
    this.filterItems('selected');
    this.selectionChange.emit(this.selectedItems);
  }

  moveAllToAvailable(): void {
    this.availableItems = [...this.availableItems, ...this.selectedItems];
    this.selectedItems = [];
    this.sortItems();
    this.selectedItem = null;
    this.filterItems('available');
    this.filterItems('selected');
    this.selectionChange.emit(this.selectedItems);
  }

  private sortItems(): void {
    this.availableItems.sort((a, b) => this.originalOrder.findIndex(item => item.value === a.value) - this.originalOrder.findIndex(item => item.value === b.value));
    this.selectedItems.sort((a, b) => this.originalOrder.findIndex(item => item.value === a.value) - this.originalOrder.findIndex(item => item.value === b.value));
  }
}
